import { Fragment } from 'react';

import Button from 'components/buttons/button';

const HandleGenericError = ({ handleClose }) => (
  <Fragment>
    <div className="error-message">
      <p className="title">Something Went Wrong</p>
      <hr />
      <p>
        We had some issues creating your account. Please check your info and try
        again.
      </p>
      <hr />
    </div>
    <div className="error-button-group">
      <Button
        className="button button-cancel"
        type="button"
        text="Cancel"
        onClick={ handleClose }
      />
      <Button
        className="button button-login"
        type="link"
        href="https://login.wheniwork.com/"
        text="Go To Login"
      />
    </div>
  </Fragment>
);

export default HandleGenericError;
